module.exports = __webpack_public_path__ + "static/media/help.f61a1a47.png";